import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const SocialMedia = () =>
  import(/* webpackChunkName: "users-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/socialmedia',
    name: 'social-media',
    component: SocialMedia,
    meta: {
      title: 'Social Media',
      auth: {
        roles: [ADMIN], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/403', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
